var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCleaningServices({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 0 960 960",
    width: "24px",
    fill: "#006B87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 920L120 640Q120 557 178.5 498.5Q237 440 320 440L360 440L360 120Q360 87 383.5 63.5Q407 40 440 40L520 40Q553 40 576.5 63.5Q600 87 600 120L600 440L640 440Q723 440 781.5 498.5Q840 557 840 640L840 920L120 920ZM200 840L280 840L280 720Q280 703 291.5 691.5Q303 680 320 680Q337 680 348.5 691.5Q360 703 360 720L360 840L440 840L440 720Q440 703 451.5 691.5Q463 680 480 680Q497 680 508.5 691.5Q520 703 520 720L520 840L600 840L600 720Q600 703 611.5 691.5Q623 680 640 680Q657 680 668.5 691.5Q680 703 680 720L680 840L760 840L760 640Q760 590 725 555Q690 520 640 520L320 520Q270 520 235 555Q200 590 200 640L200 840ZM520 440L520 120L440 120L440 440L520 440Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCleaningServices);
export default __webpack_public_path__ + "static/media/Icon_CleaningServices.790692ba5816d31478fe9b686511d5cf.svg";
export { ForwardRef as ReactComponent };